<template>
  <div>
    <q-row alignItems="center">
      <q-column flex="4">
        <div class="choose-country" @click="pickCountry = true">
          <img
            :src="flagCountry(country ? country.name : defaultCountry ? defaultCountry.name : '')"
            :alt="country ? country.name : defaultCountry ? defaultCountry.name : ''"
          />
          <q-text variant="ui-baseline" class="text">{{
            country ? country.phoneCode : defaultCountry.phoneCode
          }}</q-text>
          <arrow-down-lite height="20px" width="15px" />
        </div>
      </q-column>
      <q-column flex="10">
        <q-input
          @change="onChange"
          @input="isNumberKey($event)"
          :border="true"
          v-model="phone"
          :label="label"
          placeholder="8000000000"
          variant="formal"
          type="tel"
          maxlength="13"
          minlength="8"
        />
      </q-column>
    </q-row>

    <transition name="slide-fade" mode="out-in">
      <tool-pick-countries v-if="pickCountry" @clicked="pickCountry = false" :listCountry="list" v-model="country" />
    </transition>
  </div>
</template>

<script>
import {
  Row as QRow,
  Column as QColumn,
  Input as QInput,
  Spacer as QSpacer,
  Padder as QPadder,
  Text as QText
} from '@qoala/ui';

import ArrowDownLite from '@/assets/icons/ArrowDownLight';

import ToolPickCountries from '@/components/tool/ToolPickCountries';
import list from '@/static/data/countryList.json';

export default {
  name: 'InputPhoneNumber',
  components: {
    QRow,
    QColumn,
    QInput,
    QSpacer,
    QPadder,
    QText,
    ArrowDownLite,
    ToolPickCountries
  },
  data() {
    return {
      list,
      pickCountry: false,
      phone: '',
      country: null
    };
  },
  watch: {
    country: {
      handler() {
        this.onChange();
      }
    }
    // value: {
    //   handler() {
    //     this.setPhone();
    //   }
    // }
  },
  created() {
    if (this.value !== '') {
      this.phone = this.value;
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    defaultCountry() {
      const codeByIP = this.$store.getters['general/getCountryCode'];
      const countryFind = this.list.find(country => country.countryCode === codeByIP);
      return countryFind ? countryFind : this.list[0];
    }
  },
  methods: {
    // setPhone() {
    //   this.phone = this.value;
    // },
    isNumberKey(evt) {
      this.phone = evt.replace(/\D/g, '');
    },
    onChange() {
      this.$emit('change');
      let phoneNumber = this.phone.replace(/\D/g, '');
      if (phoneNumber.charAt(0) === '0') phoneNumber = phoneNumber.substr(1);
      let phone;
      if (this.country) {
        phone = this.country.phoneCode + phoneNumber;
      } else {
        phone = this.defaultCountry.phoneCode + phoneNumber;
      }
      if (phoneNumber === '') {
        phone = '';
      }
      this.$emit('input', phone);
    },
    flagCountry(data) {
      if (data.length > 0) {
        return `/images/icons/flags/${data.replace(/ /g, '_')}.png`;
      }
      return this.defaultCountry.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-country {
  cursor: pointer;
  padding: 10px;
  margin-right: 3px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: border-color 0.25s ease;
  background-color: #fff;
  border-radius: 4px;
  border-color: #dee2e6;
  border-width: 1px;
  border-style: solid;
  img {
    border: 1px solid #dee2e6 !important;
    max-height: 25px;
    max-width: 25px;
    height: 100%;
    width: 100%;
    background: #d3d3d3;
  }
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translteY(100%);
  opacity: 0;
}
@media screen and (max-width: 480px) {
  .choose-country {
    img {
      max-width: 18px;
    }
    svg {
      width: 10px;
    }
  }
  .text {
    font-size: 12px !important;
  }
}
</style>
